import { client } from "api";
import { Checklist } from "models/Checklist";

export type EditChecklistRequest = Partial<Checklist> & Pick<Checklist, "id">;
export type EditChecklistResponse = Checklist;

export const editChecklist = (params: EditChecklistRequest) =>
  client.patch<EditChecklistResponse>(`/checklist/${params.id}`, params).then((res) => res.data);
